import { IS_PRODUCT } from './env';

export * from './ad';
export * from './breakpoints';
export * from './certification';
export * from './cookies';
export * from './domain';
export * from './entry';
export * from './env';
export * from './naver-cts';
export * from './point';
export * from './routes';
export * from './search-params';
export * from './selector';
export * from './seo';
export * from './storage-key';
export * from './tabs';
export * from './url';

export const [GTM_ID, GA_ID] = IS_PRODUCT
  ? ['GTM-WF9XK27', 'G-WKDK663EEQ']
  : ['GTM-NJCCF8P', 'G-7FCSFN8PD7'];
